import { useState } from 'react'

import { type ICommonField } from '@/app/types/common'

export const useFilterFields = () => {
    const initialInsuranceCompanyId: ICommonField = {
        name: 'Страховая компания',
        value: '',
        error: null,
        isTouched: false,
        placeholder: 'Поиск по страховой компании'
    }

    const onChangeInsuranceCompanyId = (value: string | null) => setInsuranceCompanyId((prev) => ({ ...prev, value }))

    const [insuranceCompanyId, setInsuranceCompanyId] = useState<ICommonField>(initialInsuranceCompanyId)

    return {
        insuranceCompanyId,
        onChangeInsuranceCompanyId
    }
}
